import {Injectable, inject} from '@angular/core'
import {Router, type UrlTree} from '@angular/router'
import {NavigationService} from '@services/navigation.service'

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordGuard {
  readonly #router = inject(Router)
  readonly #navigationService = inject(NavigationService)

  canActivate(): boolean | UrlTree {
    const canActivate = this.containsStateData()
    if (!canActivate) {
      this.#navigationService.navigateRoot('/forgot-password')
    }

    return canActivate
  }

  private containsStateData(): boolean {
    const navigationState = this.#router.currentNavigation()?.extras?.state
    return !!navigationState?.forgotPasswordData
  }
}
